import { createFileRoute } from '@tanstack/react-router'

import { TelaDeAcessos } from '@/components/gestor/acessos/TelaDeAcessos'

/*
 * `/gestor/acessos`: a lista de pessoas. A guarda e a recusa por cargo moram
 * na casca (`/gestor`), então esta tela só monta para quem tem a área.
 */
export const Route = createFileRoute('/gestor/acessos')({ component: TelaDeAcessos })
